import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.assignment_summary || initialState;

export const selectAssignmentSummary = createSelector(
  [selectSlice],
  state => state,
);
